import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Project } from '@/schemas'

import { ProjectForm, ProjectValues } from './project-form.component'

interface ProjectEditProps extends ModalProps {
  project: Project
  onCancel: () => void
}

export const ProjectEdit: React.FC<ProjectEditProps> = ({ project, ...props }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm<ProjectValues>()

  React.useEffect(() => {
    form.setFieldsValue({
      name: project.name,
      email: project.email,
      range: [project.startDate ? moment(project.startDate) : null, project.endDate ? moment(project.endDate) : null],
      departmentId: project.departmentId,
      source: project.source,
      industry: project.industryId && project.scenarioId ? [project.industryId, project.scenarioId] : undefined,
      classification: project.classification,
      priority: project.priority,
      projectType: project.projectType,
      background: project.background,
      goal: project.goal,
      challenge: project.challenge,
      goalDescription: project.goalDescription,
      checkStandard: project.checkStandard,
      releaseJiraKey: project.releaseJiraKey,
      releaseNumber: project.releaseNumber,
      releaseType: project.releaseType,
    })
  }, [project])

  const { run, loading } = useRequest(
    (data) => ({
      url: '/api/project/updateProject',
      method: 'patch',
      data: {
        ...data,
        selfId: project.selfId,
      },
    }),
    {
      manual: true,
      onSuccess: () => {
        props.onCancel()
      },
    }
  )

  return (
    <Modal
      maskClosable={false}
      title={`${t('edit')}${t('project.project')}：${project.name}`}
      okText={t('save')}
      okButtonProps={{ loading }}
      onOk={() => form.submit()}
      {...props}
    >
      <ProjectForm jql={project.jql || undefined} selfId={project.selfId} form={form} onSubmit={run} />
    </Modal>
  )
}
